import classNames from 'classnames';
import s from '#components/common/mediabox/mediabox.module.scss';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

type Props = {
  src?: string;
  srcSet?: string[];
  srcMobileOnly?: string;
  alt?: string;
  aspectRatio?:
    | '16_7'
    | '16_9'
    | '16_10'
    | '3_4'
    | '3_5'
    | '4_3'
    | '8_5'
    | '1_1';
  isBackgroundTransparent?: boolean;
  lazy?: boolean;
};

const Mediabox = ({
  lazy = true,
  src,
  alt,
  aspectRatio,
  isBackgroundTransparent = false,
  srcSet,
  srcMobileOnly,
}: Props) => {
  const blockClass = classNames(s.host, {
    [s.isRatio_3_4]: !aspectRatio || aspectRatio === '3_4',
    [s.isRatio_3_5]: aspectRatio === '3_5',
    [s.isRatio_8_5]: aspectRatio === '8_5',
    [s.isRatio_16_10]: aspectRatio === '16_10',
    [s.isRatio_16_9]: aspectRatio === '16_9',
    [s.isRatio_16_7]: aspectRatio === '16_7',
    [s.isRatio_1_1]: aspectRatio === '1_1',
    [s.hasNoBgColor]: isBackgroundTransparent,
  });

  if (srcMobileOnly) {
    return (
      <div className={blockClass} data-host="mediabox">
        <picture className={s.media}>
          <source
            className={`${s.media} ${lazy && 'lazyload'}`}
            srcSet={srcMobileOnly}
            media="(max-width: 639px)"
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          />
          <img
            className={`${s.media} ${lazy && 'lazyload'}`}
            {...(lazy && { 'data-src': src, 'data-srcset': srcSet })}
            {...(!lazy && { src, srcSet: srcSet.join(',') })}
            data-sizes="auto"
            alt={alt}
            src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          />
        </picture>
      </div>
    );
  }
  return (
    <div className={blockClass} data-host="mediabox">
      <img
        className={`${s.media} ${lazy && 'lazyload'}`}
        {...(lazy && {
          'data-src': src,
          'data-srcset': srcSet,
        })}
        {...(!lazy && {
          src,
          srcSet: srcSet.join(','),
        })}
        data-sizes="auto"
        alt={alt}
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      />
    </div>
  );
};

export default Mediabox;
